import { useMedications } from "features/medications/hooks/useMedications";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";

import styles from "../../PatientOverviewModal.module.css";
import { Table } from "./Table/Table";

export const Medications = () => {
  const patientId = useCurrentPatientId();

  const { data: medications, isLoading } = useMedications(patientId);

  return (
    <div className={styles.medicalHistoryWrapper}>
      <Table
        items={medications}
        tableName="medications"
        isLoading={isLoading}
      />
    </div>
  );
};
